// extracted by mini-css-extract-plugin
module.exports = {"section":"termsInstruction_section__3yP9a","defaultWithoutTitle":"termsInstruction_defaultWithoutTitle__OKD39","hide":"termsInstruction_hide__g_G0B"};